<template>
  <div class="Menu">
    <b-navbar toggleable="lg" type="dark" variant="info" class="container">
        <b-navbar-brand href='/'>
            <b-img class="logo" src="https://wp-ocssport.ocs-sport.com/pinpos/wp-content/uploads/sites/9/2025/08/PinPos_Logo.png"></b-img>
            <!-- <span class="clubText">.club</span> -->
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <template v-if="this.$route.name == 'home'">
          <b-collapse id="nav-collapse" is-nav>
              <b-navbar-nav class="ml-auto">
                  <h3 class="download">Download The App Today</h3>
                  <template v-if="isMobile(true)">
                    <span class="sidebyside">
                      <div class="navItems" href="https://apps.apple.com/us/app/pin-pos/id6748916022" target="_blank">
                        <img class="storeIcons" src="https://wp-ocssport.ocs-sport.com/pinpos/wp-content/uploads/sites/9/2025/08/AppStore.png">
                      </div>
                      <div class="navItems" href="https://play.google.com/store/apps/details?id=com.ocssport.apps.pinpos&hl=en_GB" target="_blank">
                        <img class="storeIcons" src="https://wp-ocssport.ocs-sport.com/pinpos/wp-content/uploads/sites/9/2025/08/GooglePlay.png">
                      </div>
                    </span>
                  </template>
                  <template v-else>
                    <b-nav-item class="navItems appleStoreItem" href="https://apps.apple.com/us/app/pin-pos/id6748916022" target="_blank">
                      <img class="storeIcons" src="https://wp-ocssport.ocs-sport.com/pinpos/wp-content/uploads/sites/9/2025/08/AppStore.png">
                    </b-nav-item>
                    <b-nav-item class="navItems goolgeStoreItem" href="https://play.google.com/store/apps/details?id=com.ocssport.apps.pinpos&hl=en_GB" target="_blank">
                      <img class="storeIcons" src="https://wp-ocssport.ocs-sport.com/pinpos/wp-content/uploads/sites/9/2025/08/GooglePlay.png">
                    </b-nav-item>
                  </template>
              </b-navbar-nav>
          </b-collapse>
        </template>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  props: {

  },
  methods: {
      isMobile() {
        if( screen.width <= 500 ) {
            return true;
        }
        else {
            return false;
        }
    },
    scroll() {
      var score = document.getElementById("about");
      score.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    },
    scrolltwo() {
      var score = document.getElementById("membership");
      score.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    },
    scrollthree() {
      var score = document.getElementById("hotLap");
      score.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    },
    // scrollthree() {
    //   var score = document.getElementById("contact");
    //   score.scrollIntoView({
    //     behavior: "smooth",
    //     block: "start",
    //     inline: "nearest",
    //   });
    // },
    // scrollfour() {
    //   var score = document.getElementById("blog");
    //   score.scrollIntoView({
    //     behavior: "smooth",
    //     block: "start",
    //     inline: "nearest",
    //   });
    // },
  },
  mounted() {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3.download {
    margin-top: 25px;
    font-size: 34px;
    font-weight: bold;
    font-family: DIN Condensed, Bold;
}
.callSec {
    margin-right: 4px;
    margin-bottom: 17px;
  }
  .buyText {
    color: #fff;
    font-size: 18px;
    font-weight: 700;
    font-family: noto-sans, sans-serif;
  }
  .nonPulse {
    font-size: 18px;
    font-weight: bold;
    font-family: "noto-sans", sans-serif;
    color: #fff;
    position: absolute;
    /* right: -15px; */
    right: 0px;
    top: 4px;
  }
  ::v-deep .pulse{
    height: 40px;
    background: #ff001e;
    border-radius: 50px;
    color: #FFF;
    font-size: 20px;
    text-align: center;
    line-height: 40px;
    font-family: sans-serif;
    animation: animate-pulse-9bcc0be2 3s linear infinite;
    cursor: pointer;
  }
  @keyframes animate-pulse{
      0%{
          box-shadow: 0 0 0 0 rgba(255,109,74,0.7),  0 0 0 0 rgba(255,109,74,0.7);
      }
      40%{
          box-shadow: 0 0 0 50px rgba(255,109,74,0.0),  0 0 0 0 rgba(255,109,74,0.7);
      }
      80%{
          box-shadow: 0 0 0 50px rgba(255,109,74,0.0),  0 0 0 30px rgba(255,109,74,0);
      }
      100%{
          box-shadow: 0 0 0 0 rgba(255,109,74,0.0),  0 0 0 30px rgba(255,109,74,0);
      }
      
  }
  .mobileWidth.col-sm-6 {
    width: 50%;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .buyGiftVoucher {
    background-color: #d80e1f;
    border-color: #d80e1f !important;
    border-radius: 50px;
    width: 163px;
    height: 31px;
    line-height: 1;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    width: 200px;
    height: 35px;
    /* margin-top: 65px; */
    font-family: "noto-sans", sans-serif;
    border: none;
    z-index: 99;
    cursor: pointer;
    margin-left: 6em;
  }
  /* .buyGiftVoucher:hover {
    background-color: #fff;
    border-color: #d80e1f !important;
    border-radius: 50px;
    width: 163px;
    height: 31px;
    line-height: 1;
    color: #000!important;
    font-size: 18px;
    font-weight: bold;
    width: 200px;
    height: 35px;
    font-family: "noto-sans", sans-serif;
    border: none;
    z-index: 99;
    cursor: pointer;
    margin-left: 6em;
  }
  .nonPulse:hover {
    font-size: 18px;
    font-weight: bold;
    font-family: "noto-sans", sans-serif;
    color: #000000!important;
    position: absolute;
    right: 0px;
    top: 4px;
  } */
  .phonenumber {
    color: #d80e1f;
  }
  .phonenumber:hover {
    color: #000;
  }
  .number { 
    color: #d80e1f;
    opacity: 1;
    text-align: right;
    font-weight: bold;
    /* padding-right: 50px; */
    font-size: 20px;
    margin-left: 1em;
    position: relative;
    top: 10px;
  }
  .numberMob { 
    color: #d80e1f;
    opacity: 1;
    text-align: left;
    font-weight: bold;
    /* padding-right: 50px; */
    font-size: 20px;
  }
  .buyGiftVoucherMob {
    background-color: #d80e1f;
    border-color: #d80e1f !important;
    border-radius: 50px;
    width: 163px;
    height: 31px;
    line-height: 1;
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    width: 180px;
    height: 30px;
    /* margin-top: 65px; */
    font-family: "noto-sans", sans-serif;
    border: none;
    z-index: 99;
    cursor: pointer;
    float: right;
  }
  .buyGiftVoucherMob:hover {
    background-color: #ffffff;
    border-color: #d80e1f !important;
    border-radius: 50px;
    width: 163px;
    height: 31px;
    line-height: 1;
    color: #000;
    font-size: 15px;
    font-weight: bold;
    width: 180px;
    height: 30px;
    /* margin-top: 65px; */
    font-family: "noto-sans", sans-serif;
    border: none;
    z-index: 99;
    cursor: pointer;
    float: right;
  }
    img.golfParkLogo {
      /* width: 70px; */
      height: 30px;
    }
    li.nav-item.navItems.appleStoreItem {
      padding-right: 0px;
    }
    li.nav-item.navItems.goolgeStoreItem {
      padding-left: 0px;
    }
    img.storeIcons {
      width: 42px;
    }
    .clubText {
      color: #FF7600;
      font-style: italic;
      font-size: 29px;
      font-weight: bold;
      position: relative;
      top: 15px;
      left: -11px;
    }
    .Menu {
      /* display: none; */
      background-color: #2D2D39;
    }
    .hide {
      opacity:0;
      display: none;
    }
    .show {
      opacity: 1;
      /* background: #010322; */
      /* position: fixed; */
      width: 100%;
      z-index: 999;
    }
    img.supportLogos {
      width: 45px;
    }
    ::v-deep .btn-danger {
      color: #fff;
      background-color: #efd170;
      border-color: #efd170!important;
    }
    .navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
        color: #D80E1F;
    }
    .navItems {
        /* padding-right: 40px;
        padding-left: 40px; */
        /* padding-right: 21px;
        padding-left: 21px; */
        padding-right: 10px;
        padding-left: 10px;
        line-height: 3;
        scroll-behavior: smooth;
        color:#fff;
    }
    .navItems:hover {
        /* padding-right: 30px;
        padding-left: 30px; */
        line-height: 3;
        scroll-behavior: smooth;
        color:rgb(232 63 75);
        text-decoration: none;
    }
    .logo {
        width: 190px;
    }
    .Menu {
        background-color: #2D2D39 !important;
        padding-top: 20px;
        padding-bottom: 20px;
    }
    .bg-info {
        background-color: #2D2D39 !important;
    }
    .navbar-light .navbar-nav .nav-link {
        color: #1A1A1A;
        font-size: 20px;
        font-family: "noto-sans", sans-serif;
        font-weight: 600;
        font-style: normal;
    }
    button.getInTouch {
        background-color: #D80E1F;
        border-color: #D80E1F!important;
        border-radius: 50px;
        width: 163px;
        height: 31px;
        line-height: 1;
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        width: 259px;
        height: 54px;
    }
    button.getInTouch:hover {
        background-color: #707070;
        border-color: #707070!important;
        color: #fff;
    }
    
    @media only screen and (max-width: 768px) {
      .bg-info {
        background-color: #2D2D39 !important;
        z-index: 9999;
      }
    }
    @media only screen and (max-width: 500px) {
    span.sidebyside {
        display: inline-flex;
        margin: auto;
    }
    .number { 
        color: #DD112B;
        opacity: 1;
        text-align: center;
        font-weight: bold;
        padding-right: 0px;
        font-size: 20px;
      }
      img.storeIcons {
          width: 35px;
          padding-right: 5px;
          /* margin-right: -15px; */
      }
      .logo {
          width: 150px;
      }
      .Menu{
          padding-top: 5px;
          padding-bottom: 5px;
      }
      img.supportLogos {
          width: 50px;
          margin-top: 15px;
      }
    }
    @media only screen and (max-width: 375px) {
    .numberMob { 
      color: #DD112B;
      opacity: 1;
      text-align: left;
      font-weight: bold;
      /* padding-right: 50px; */
      font-size: 16px;
    }
    .buyGiftVoucherMob {
      background-color: #d80e1f;
      border-color: #d80e1f !important;
      border-radius: 50px;
      width: 163px;
      height: 31px;
      line-height: 1;
      color: #fff;
      font-size: 13px;
      font-weight: bold;
      width: 150px;
      height: 25px;
      /* margin-top: 65px; */
      font-family: "noto-sans", sans-serif;
      border: none;
      z-index: 99;
      cursor: pointer;
      float: right;
    }
    .buyGiftVoucherMob:hover {
      background-color: #ffffff;
      border-color: #d80e1f !important;
      border-radius: 50px;
      width: 163px;
      height: 31px;
      line-height: 1;
      color: #000000;
      font-size: 13px;
      font-weight: bold;
      width: 150px;
      height: 25px;
      /* margin-top: 65px; */
      font-family: "noto-sans", sans-serif;
      border: none;
      z-index: 99;
      cursor: pointer;
      float: right;
    }
  }
</style>
